import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_a2603301-837e-467e-952a-d7e2edb4c197/artifacts/3ut7qksg_file_0000000043b081f5a40b26af34420fa3.webp";

const Footer = () => (
  <footer className="border-t border-white/10 bg-[#050505]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
      <div className="grid md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <img src={LOGO} alt="GI Remodeling" className="h-16 w-16 object-contain mb-4" />
          <p className="font-serif text-2xl">
            <span className="gold-gradient-text">GI</span> <span className="silver-gradient-text">Remodeling</span>
          </p>
          <p className="text-white/50 text-sm mt-2 font-body tracking-wide uppercase">Design • Build • Transform</p>
        </div>

        <div className="font-body text-sm">
          <p className="text-white/70 mb-4 uppercase tracking-widest text-xs">Explore</p>
          <div className="space-y-2">
            <Link to="/about" className="block text-white/60 hover:text-gold transition-colors">About Us</Link>
            <Link to="/services" className="block text-white/60 hover:text-gold transition-colors">Services</Link>
            <Link to="/before-after" className="block text-white/60 hover:text-gold transition-colors">Before / After</Link>
            <Link to="/guarantees" className="block text-white/60 hover:text-gold transition-colors">Guarantees</Link>
            <Link to="/portal" data-testid="footer-portal-link" className="block text-white/60 hover:text-gold transition-colors">Client Portal</Link>
          </div>
        </div>

        <div className="space-y-4 font-body text-sm">
          <p className="text-white/70 mb-1 uppercase tracking-widest text-xs">Contact</p>
          <a href="tel:+15712688498" data-testid="footer-phone" className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors">
            <Phone size={16} className="text-gold" /> +1 (571) 268-8498
          </a>
          <a href="tel:+15715012905" data-testid="footer-phone-2" className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors">
            <Phone size={16} className="text-gold" /> +1 (571) 501-2905
          </a>
          <a href="mailto:info@giremodeling.net" data-testid="footer-email" className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors">
            <Mail size={16} className="text-gold" /> info@giremodeling.net
          </a>
          <p className="flex items-start gap-3 text-white/70">
            <MapPin size={16} className="text-gold mt-0.5" /> Proudly serving all of Virginia
          </p>
        </div>

        <div className="font-body text-sm text-white/50">
          <p className="text-white/70 mb-3 uppercase tracking-widest text-xs">GI Remodeling LLC</p>
          <p>Licensed & Insured</p>
          <p className="mt-1">1-Year Workmanship Warranty</p>
          <p className="mt-2">Mon – Sat · 8:00 – 18:00</p>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40 font-body">
        <p>© {new Date().getFullYear()} GI Remodeling LLC. All rights reserved. Serving Virginia.</p>
        <Link data-testid="admin-link" to="/login" className="hover:text-gold transition-colors uppercase tracking-widest">Admin</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
